import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";

import { cn } from "@/lib/utils";

function Switch({
  className,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        "aero:peer aero:data-[state=checked]:bg-brand-primary aero:data-[state=unchecked]:bg-brand-primary/30 aero:focus-visible:border-ring aero:focus-visible:ring-ring/50 aero:dark:data-[state=unchecked]:bg-input/80 aero:inline-flex aero:h-[1.15rem] aero:w-8 aero:shrink-0 aero:items-center aero:!rounded-full aero:border aero:border-transparent aero:shadow-xs aero:transition-all aero:outline-none aero:focus-visible:ring-[3px] aero:disabled:cursor-not-allowed aero:disabled:opacity-50",
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          "aero:bg-background aero:dark:data-[state=unchecked]:bg-foreground aero:dark:data-[state=checked]:bg-brand-primary-foreground aero:pointer-events-none aero:block aero:size-4 aero:!rounded-full aero:ring-0 aero:transition-transform aero:data-[state=checked]:translate-x-[calc(100%-2px)] aero:data-[state=unchecked]:translate-x-0"
        )}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
